import React, { useContext } from "react"
import { cond, always, T } from "ramda"
import { LinkIcon } from "@pga/pga-component-library"

import { Header as StyledHeader, ExternalLink } from "./styled"
import { hasNullCurrentLevel, hasLinkAndLevel } from "./utils"
import { isAffiliate, isPreQualifier, isAssociate } from "../../../utils"
import {
  useEducationPurchaseLinkProps,
  useResolveEducationPgmPurchaseUrl,
} from "../../../../utils/educationPgmPurchase"
import MembershipJourneyContext from "../../MembershipJourney/MembershipJourneyContext"
import { shouldSuppressAdvancementCtas } from "../../../../utils/shouldSuppressAdvancementCtas"

const headerText = cond([
  [isAffiliate, always("Affiliate Curriculum")],
  [isPreQualifier, always("Pre Qualifying Curriculum")],
  [isAssociate, always("Associate Curriculum")],
  [T, always("Associate Curriculum")],
])

export const HeaderDefault = ({ text }) => <StyledHeader>{text}</StyledHeader>

const HeaderWithPurchaseLink = ({ me, purchaseLink, nextLevel }) => {
  const resolveEducationPgmPurchaseUrl = useResolveEducationPgmPurchaseUrl()
  const purchaseUrl = resolveEducationPgmPurchaseUrl(purchaseLink(me.pgaId))
  const purchaseLinkProps = useEducationPurchaseLinkProps(purchaseUrl)

  return (
    <div className="pb-3">
      <StyledHeader display="inline">{headerText(me)}</StyledHeader>
      {nextLevel && (
        <ExternalLink
          url={purchaseLinkProps.href}
          onClick={purchaseLinkProps.onClick}
        >
          | Purchase Level {nextLevel} <LinkIcon className="px-1" />
        </ExternalLink>
      )}
    </div>
  )
}

const Header = ({ me, nextLevel, purchaseLink }) => {
  const journeyContext = useContext(MembershipJourneyContext)
  const suppressPurchase = shouldSuppressAdvancementCtas({
    standing: journeyContext?.progressStanding,
  })

  if (
    !suppressPurchase &&
    hasNullCurrentLevel(me) &&
    hasLinkAndLevel(purchaseLink, nextLevel)()
  ) {
    return <HeaderWithPurchaseLink {...{ me, nextLevel, purchaseLink }} />
  }

  return <HeaderDefault text={headerText(me)} />
}

export default Header
